import BusinessesDirectories from 'pages/businesses'
export default BusinessesDirectories
